import React from "react";
import "./loading.less";

const LoadingSpinner = () => (
	<div className="loading-container">

		<div className="loading-text">Loading...</div>
		<div className="loading-spinner"></div>
	</div>
);

export default LoadingSpinner;
